export { formatCLP } from '@impacta/shared/utils/format';
